module.exports = __webpack_public_path__ + "fonts/DINPro-Medium.90d4bd83.otf";